import { Field, Form, FormikProvider, useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { useDispatch } from "react-redux";
import Accordion from 'react-bootstrap/Accordion';
import allowNumbersOnly, { handlePaste } from "../../CommonUtils/CommonValidations";
import { AC_YEAR_OLD } from "../../CommonUtils/contextVariables";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";
export default function AfflRenewCourseIntake() {
    const hasFetchedData = useRef(false)
    const [showRenewalOFExistingCourse, setRenewalOFExistingCourseData] = useState([]);
    const [showWithdrawlCourse, setWithdrawlCourseData] = useState([]);
    const [showadditionalSectionsData, setadditionalSectionsData] = useState([]);
    const [showadditionalNewCoursesData, setadditionalNewCoursesData] = useState([]);
    const dispatch = useDispatch()
    const afflCourseIntakeformik = useFormik({
        initialValues: {

            totNoOfCoursesRenewal: "",
            totNoOfCombinationsRenewal: "",
            totClassAreaWithdrawl: "",
            totNoOfCoursesAfterWithdrawl: "",
            totNoOfCombinationsAfterWithdrawl: "",
            totNoOfSectionsAfterWithdrawl: "",
            totNoOfCoursesAdditional: "",
            totNoOfCombinationsAdditional: "",
            totNoOfSectionsRequestedAdditional: "",
            totNoOfSectionsAfterNewSectionsAdditional: "",
            totClassAreaAdditional: "",
            totNoOfCoursesNewCourse: "",
            totNoOfCombinationsNewCourse: "",
            totNoOfSectionsNewCourse: "",
            totClassAreaAdditionalNewCourse: "",
        },
        onSubmit: (values) => {

        }
    })
    function SaveRenewExistingCourses(totNoOfCoursesRenewalvalue, totNoOfCombinationsRenewalValue) {
        if (totNoOfCoursesRenewalvalue === "" || totNoOfCoursesRenewalvalue === null || totNoOfCoursesRenewalvalue === undefined) {
            Swal.fire("Please enter total no of courses.", '', 'warning')
            return;
        }
        if (totNoOfCombinationsRenewalValue === "" || totNoOfCombinationsRenewalValue === null || totNoOfCombinationsRenewalValue === undefined) {
            Swal.fire("Please enter total no of combinations.", '', 'warning')
            return;
        }
        const renewExistingCoursesPayload = {

            totNoOfCoursesRenewal: totNoOfCoursesRenewalvalue,
            totNoOfCombinationsRenewal: totNoOfCombinationsRenewalValue
        }
        Swal.fire({
            title: "Are you sure want to submit the data?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Save & Continue",
            cancelButtonText: "Cancel",
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                let saveUrl = config.url.API_URL + `saveRenewExistingCourses`
                CommonAxiosPost(saveUrl, renewExistingCoursesPayload, dispatch).then((resAtsave) => {
                    if (resAtsave?.data?.scode === '01') {
                        Swal.fire('Successfully Submitted', '', 'success').then((res) => {
                            if (res?.isConfirmed) {
                                GetRenewalOFExistingCourseData()
                            }
                        })
                    }
                    else {
                        failureAlert("Failed to submit")

                    }
                })
            }
        });
    }
    function SaveWithdrawlCourses(totNoOfCoursesAfterWithdrawlvalue,
        totNoOfCombinationsAfterWithdrawlvalue, totNoOfSectionsAfterWithdrawlvalue, totClassAreaWithdrawlvalue,) {

        if (totNoOfCoursesAfterWithdrawlvalue === "" || totNoOfCoursesAfterWithdrawlvalue === null || totNoOfCoursesAfterWithdrawlvalue === undefined) {
            Swal.fire("Please enter total no of courses after withdrawl.", '', 'warning')
            return;
        }
        if (totNoOfCombinationsAfterWithdrawlvalue === "" || totNoOfCombinationsAfterWithdrawlvalue === null || totNoOfCombinationsAfterWithdrawlvalue === undefined) {
            Swal.fire("Please enter total no of combinations after withdrawl.", '', 'warning')
            return;
        }
        if (totNoOfSectionsAfterWithdrawlvalue === "" || totNoOfSectionsAfterWithdrawlvalue === null || totNoOfSectionsAfterWithdrawlvalue === undefined) {
            Swal.fire("Please enter total no of sections after withdrawl.", '', 'warning')
            return;
        }
        if (totClassAreaWithdrawlvalue === "" || totClassAreaWithdrawlvalue === null || totClassAreaWithdrawlvalue === undefined) {
            Swal.fire("Please enter total class room area", '', 'warning')
            return;
        }
        const WithdrawCoursesPayload = {

            totClassAreaWithdrawl: totClassAreaWithdrawlvalue,
            totNoOfCoursesAfterWithdrawl: totNoOfCoursesAfterWithdrawlvalue,
            totNoOfCombinationsAfterWithdrawl: totNoOfCombinationsAfterWithdrawlvalue,
            totNoOfSectionsAfterWithdrawl: totNoOfSectionsAfterWithdrawlvalue,
        }
        Swal.fire({
            title: "Are you sure want to submit the data?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Save & Continue",
            cancelButtonText: "Cancel",
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                let saveUrl = config.url.API_URL + `saveWithdrawlCourses`
                CommonAxiosPost(saveUrl, WithdrawCoursesPayload, dispatch).then((resAtsave) => {
                    if (resAtsave?.data?.scode === '01') {
                        Swal.fire('Successfully Submitted', '', 'success').then((res) => {
                            if (res?.isConfirmed) {
                                GetwithdrawlTotCoursesData()
                            }
                        })
                    }
                    else {
                        failureAlert("Failed to submit")

                    }
                })
            }
        });
    }
    function SaveAdditionalSectionsExistingCourses(totNoOfCoursesAdditionalvalue,
        totNoOfCombinationsAdditionalvalue,
        totNoOfSectionsRequestedAdditionalvalue,
        totNoOfSectionsAfterNewSectionsAdditionalvalue,
        totClassAreaAdditionalvalue) {
        if (totNoOfCoursesAdditionalvalue === "" || totNoOfCoursesAdditionalvalue === null || totNoOfCoursesAdditionalvalue === undefined) {
            Swal.fire("Please enter total no of courses.", '', 'warning')
            return;
        }
        if (totNoOfCombinationsAdditionalvalue === "" || totNoOfCombinationsAdditionalvalue === null || totNoOfCombinationsAdditionalvalue === undefined) {
            Swal.fire("Please enter total no of combinations.", '', 'warning')
            return;
        }
        if (totNoOfSectionsRequestedAdditionalvalue === "" || totNoOfSectionsRequestedAdditionalvalue === null || totNoOfSectionsRequestedAdditionalvalue === undefined) {
            Swal.fire("Please enter total no of sections requested.", '', 'warning')
            return;
        }
        if (totNoOfSectionsAfterNewSectionsAdditionalvalue === "" || totNoOfSectionsAfterNewSectionsAdditionalvalue === null || totNoOfSectionsAfterNewSectionsAdditionalvalue === undefined) {
            Swal.fire("Please enter total no of sections after new sections added.", '', 'warning')
            return;
        }
        if (totClassAreaAdditionalvalue === "" || totClassAreaAdditionalvalue === null || totClassAreaAdditionalvalue === undefined) {
            Swal.fire("Please enter total class room area.", '', 'warning')
            return;
        }
        const AdditionalSectionsPayload = {

            totNoOfCoursesAdditional: totNoOfCoursesAdditionalvalue,
            totNoOfCombinationsAdditional: totNoOfCombinationsAdditionalvalue,
            totNoOfSectionsRequestedAdditional: totNoOfSectionsRequestedAdditionalvalue,
            totNoOfSectionsAfterNewSectionsAdditional: totNoOfSectionsAfterNewSectionsAdditionalvalue,
            totClassAreaAdditional: totClassAreaAdditionalvalue,
        }
        Swal.fire({
            title: "Are you sure want to submit the data?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Save & Continue",
            cancelButtonText: "Cancel",
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                let saveUrl = config.url.API_URL + `saveAdditionalSectionsExstCourses`
                CommonAxiosPost(saveUrl, AdditionalSectionsPayload, dispatch).then((resAtsave) => {
                    if (resAtsave?.data?.scode === '01') {
                        Swal.fire('Successfully Submitted', '', 'success').then((res) => {
                            if (res?.isConfirmed) {
                                GetadditionalTotSectionsData()
                            }
                        })
                    }
                    else {
                        failureAlert("Failed to submit")


                    }
                })
            }
        });
    }
    function SaveAdditionalNewCourses(totNoOfCoursesNewCourseValue,
        totNoOfCombinationsNewCourseValue,
        totNoOfSectionsNewCourseValue,
        totClassAreaAdditionalNewCourseValue) {
        if (totNoOfCoursesNewCourseValue === "" || totNoOfCoursesNewCourseValue === null || totNoOfCoursesNewCourseValue === undefined) {
            Swal.fire("Please enter total no of courses after new course/combinantion.", '', 'warning')
            return;
        }
        if (totNoOfCombinationsNewCourseValue === "" || totNoOfCombinationsNewCourseValue === null || totNoOfCombinationsNewCourseValue === undefined) {
            Swal.fire("Please enter total no of combinations after new course/combinantion.", '', 'warning')
            return;
        }
        if (totNoOfSectionsNewCourseValue === "" || totNoOfSectionsNewCourseValue === null || totNoOfSectionsNewCourseValue === undefined) {
            Swal.fire("Please enter total no of sections after new course/combinantion.", '', 'warning')
            return;
        }
        if (totClassAreaAdditionalNewCourseValue === "" || totClassAreaAdditionalNewCourseValue === null || totClassAreaAdditionalNewCourseValue === undefined) {
            Swal.fire("Please enter total class room area after new course/combinantion.", '', 'warning')
            return;
        }
        const AdditionalNewCoursesPayload = {

            totNoOfCoursesNewCourse: totNoOfCoursesNewCourseValue,
            totNoOfCombinationsNewCourse: totNoOfCombinationsNewCourseValue,
            totNoOfSectionsNewCourse: totNoOfSectionsNewCourseValue,
            totClassAreaAdditionalNewCourse: totClassAreaAdditionalNewCourseValue,
        }
        Swal.fire({
            title: "Are you sure want to submit the data?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Save & Continue",
            cancelButtonText: "Cancel",
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                let saveUrl = config.url.API_URL + `saveAdditionalNewCourses`
                CommonAxiosPost(saveUrl, AdditionalNewCoursesPayload, dispatch).then((resAtsave) => {
                    if (resAtsave?.data?.scode === '01') {
                        successAlert2('Successfully Submitted').then((res) => {
                            if (res?.isConfirmed) {
                                GetAdditionalTotNewCourseData()
                            }
                        })
                    }
                    else {
                        failureAlert("Failed to submit")

                    }
                })
            }
        });

    }
    function GetRenewalOFExistingCourseData() {
        let affilCoursegurl = config.url.API_URL + "getrenewalCourses";
        CommonAxiosGet(affilCoursegurl, dispatch).then((resAyaffilCourse) => {
            if (resAyaffilCourse?.data?.scode === "01") {
                setRenewalOFExistingCourseData(resAyaffilCourse?.data?.getrenewalCourses)
                afflCourseIntakeformik?.setFieldValue("totNoOfCoursesRenewal", resAyaffilCourse?.data?.getrenewalCourses[0]?.no_courses)
                afflCourseIntakeformik?.setFieldValue("totNoOfCombinationsRenewal", resAyaffilCourse?.data?.getrenewalCourses[0]?.branch)
            }
            else {
                setRenewalOFExistingCourseData([])
            }
        })
    }

    function GetwithdrawlData() {
        let affilwithdrawlgurl = config.url.API_URL + "getwithdrawlCourses";
        CommonAxiosGet(affilwithdrawlgurl, dispatch).then((resAyaffilwithdrawlCourse) => {
            if (resAyaffilwithdrawlCourse?.data?.scode === "01") {
                setWithdrawlCourseData(resAyaffilwithdrawlCourse?.data?.getwithdrawlCourses)
            }
            else {
                setWithdrawlCourseData([])
            }
        })
    }
    const [showWithdrawlTotCoursesCourseData, setWithdrawlTotCoursesCourseData] = useState([]);
    function GetwithdrawlTotCoursesData() {
        let affilwithdrawlTotCoursegurl = config.url.API_URL + "getwithdrawlTotCourses";
        CommonAxiosGet(affilwithdrawlTotCoursegurl, dispatch).then((resAffilwithdrawlTotCourse) => {
            if (resAffilwithdrawlTotCourse?.data?.scode === "01") {
                setWithdrawlTotCoursesCourseData(resAffilwithdrawlTotCourse?.data?.getwithdrawlTotCourses)
                afflCourseIntakeformik?.setFieldValue("totNoOfCoursesAfterWithdrawl", resAffilwithdrawlTotCourse?.data?.getwithdrawlTotCourses[0]?.tot_no_of_courses_after_withdrawl)
                afflCourseIntakeformik?.setFieldValue("totNoOfCombinationsAfterWithdrawl", resAffilwithdrawlTotCourse?.data?.getwithdrawlTotCourses[0]?.tot_no_of_combinations_after_withdrawl)
                afflCourseIntakeformik?.setFieldValue("totNoOfSectionsAfterWithdrawl", resAffilwithdrawlTotCourse?.data?.getwithdrawlTotCourses[0]?.tot_no_of_sections_after_withdrawl)
                afflCourseIntakeformik?.setFieldValue("totClassAreaWithdrawl", resAffilwithdrawlTotCourse?.data?.getwithdrawlTotCourses[0]?.tot_class_area_withdrawl)
            }
            else {
                setWithdrawlTotCoursesCourseData([])
            }
        })
    }
    function GetadditionalSectionsData() {
        let affilSectionsgurl = config.url.API_URL + "getadditionalSections"
        CommonAxiosGet(affilSectionsgurl, dispatch).then((resAffilSections) => {
            if (resAffilSections?.data?.scode === "01") {
                setadditionalSectionsData(resAffilSections?.data?.getadditionalSections)
            }
            else {
                setadditionalSectionsData([])
            }
        })
    }

    function GetadditionalTotSectionsData() {
        let affilTotSectionurl = config.url.API_URL + "getadditionalTotSections"
        CommonAxiosGet(affilTotSectionurl, dispatch).then((resAffiTotSection) => {
            if (resAffiTotSection?.data?.scode === "01") {
                //  setadditionalTotSectionsData(resAffiTotSection?.data?.getadditionalTotSections)
                afflCourseIntakeformik?.setFieldValue("totNoOfCoursesAdditional", resAffiTotSection?.data?.getadditionalTotSections[0]?.tot_no_of_courses_additional)
                afflCourseIntakeformik?.setFieldValue("totNoOfCombinationsAdditional", resAffiTotSection?.data?.getadditionalTotSections[0]?.tot_no_of_combinations_additional)
                afflCourseIntakeformik?.setFieldValue("totNoOfSectionsRequestedAdditional", resAffiTotSection?.data?.getadditionalTotSections[0]?.tot_no_of_sections_requested_additional)
                afflCourseIntakeformik?.setFieldValue("totNoOfSectionsAfterNewSectionsAdditional", resAffiTotSection?.data?.getadditionalTotSections[0]?.tot_no_of_sectionsafter_new_sections_additional)
                afflCourseIntakeformik?.setFieldValue("totClassAreaAdditional", resAffiTotSection?.data?.getadditionalTotSections[0]?.tot_class_area_aditional)
            }
            // else {
            //     setadditionalTotSectionsData([])
            // }
        })
    }
    function GetAdditionalNewCourseData() {
        let affilTotSectionurl = config.url.API_URL + "getadditionalNewCourse"
        CommonAxiosGet(affilTotSectionurl, dispatch).then((resAffiTotSection) => {
            if (resAffiTotSection?.data?.scode === "01") {
                setadditionalNewCoursesData(resAffiTotSection?.data?.getadditionalNewCourse)
            }
            else {
                setadditionalNewCoursesData([])
            }
        })
    }
    //   const [showadditionalTotNewCoursesData, setadditionalTotNewCoursesData] = useState([]);
    function GetAdditionalTotNewCourseData() {
        let affilTotSectionurl = config.url.API_URL + "getadditionalTotNewCourse"
        CommonAxiosGet(affilTotSectionurl, dispatch).then((resAffiTotSection) => {
            if (resAffiTotSection?.data?.scode === "01") {
                //   setadditionalTotNewCoursesData(resAffiTotSection?.data?.getadditionalTotNewCourse)
                afflCourseIntakeformik?.setFieldValue("totNoOfCoursesNewCourse", resAffiTotSection?.data?.getadditionalTotNewCourse[0]?.tot_no_of_courses_new_course)
                afflCourseIntakeformik?.setFieldValue("totNoOfCombinationsNewCourse", resAffiTotSection?.data?.getadditionalTotNewCourse[0]?.tot_no_of_combinations_new_course)
                afflCourseIntakeformik?.setFieldValue("totNoOfSectionsNewCourse", resAffiTotSection?.data?.getadditionalTotNewCourse[0]?.tot_no_of_sections_new_course)
                afflCourseIntakeformik?.setFieldValue("totClassAreaAdditionalNewCourse", resAffiTotSection?.data?.getadditionalTotNewCourse[0]?.tot_class_area_aditional_new_course)
            }
            // else {
            //     setadditionalTotNewCoursesData([])
            // }
        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetRenewalOFExistingCourseData();
            GetwithdrawlData();
            GetwithdrawlTotCoursesData();
            GetadditionalSectionsData();
            GetadditionalTotSectionsData();
            GetAdditionalNewCourseData();
            GetAdditionalTotNewCourseData()
            hasFetchedData.current = true
        }
    }, [])

    return (
        <>
            <bie.Container fluid className="px-1" >
                <CommonFormHeading heading={"Calculation Details"} />

                {/* <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className="">
                        <div className="inner-herbpage-service-title1">
                            <h1>Calculation Details</h1>
                        </div>
                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
                        <button className="breadcrumb-item"><a href="/dashboard" className='affl-dash'><FaHome size={30} /></a></button>
                    </bie.Col>
                </bie.Row> */}
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={afflCourseIntakeformik}>
                        <Form onChange={afflCourseIntakeformik.handleChange} onSubmit={afflCourseIntakeformik.handleSubmit} className="form_adjust" >
                            <Accordion className="affl-accord">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <h4 className="mb-0">1. Renewal of Existing Courses</h4>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="inner-herbpage-service-title-sub pt-0"  >
                                            <h1 className="">Renewal of Existing Courses</h1>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                                <thead>
                                                    <tr>
                                                        <th>Total Number of Courses</th>
                                                        <th>Total Number of Branch/combination</th>
                                                        <th>Total Number of Sections</th>
                                                        <th>Total Approved Intake (existing)</th>
                                                        <th>Utilized Number of Class Rooms</th>
                                                        <th>Un-Utilized Number of Class Rooms</th>
                                                        <th>Total No. of Available Class Rooms</th>
                                                        <th>Total Utilized Class Room Area</th>
                                                        <th>Total Un-Utilized Class Room Area</th>
                                                        <th>Utilized Number of Class Rooms/ Total Number of Students (Existing)</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ textAlign: "center" }}>
                                                    <tr>
                                                        <td>
                                                            <Field type="text" className="form-control" name="totNoOfCoursesRenewal"
                                                                maxLength="2" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control" name="totNoOfCombinationsRenewal"
                                                                maxLength="2" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                        </td>
                                                        <td>{showRenewalOFExistingCourse[0]?.no_sec}</td>
                                                        <td>{showRenewalOFExistingCourse[0]?.intake}</td>
                                                        <td>{showRenewalOFExistingCourse[0]?.utilized}</td>
                                                        <td>{showRenewalOFExistingCourse[0]?.un_utilized}</td>
                                                        <td>{showRenewalOFExistingCourse[0]?.total_inst_area}</td>
                                                        <td>{showRenewalOFExistingCourse[0]?.total_area_utilized}</td>
                                                        <td>{showRenewalOFExistingCourse[0]?.total_area_unutilized}</td>
                                                        <td>{showRenewalOFExistingCourse[0]?.sss}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <bie.Row className="px-3 pt-4">
                                            <div className='d-flex flex-row justify-content-end pb-1'>
                                                <button type="button" className="btn rounded-0 btn-success btn-sm" onClick={() => {
                                                    SaveRenewExistingCourses(afflCourseIntakeformik?.values?.totNoOfCoursesRenewal, afflCourseIntakeformik?.values?.totNoOfCombinationsRenewal)
                                                }}>Save & Continue</button>
                                            </div>
                                        </bie.Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1"
                                //    onClick={()=>{ClearOtherFields("1")}}
                                >
                                    <Accordion.Header>
                                        <h4 className="mb-0">2. Withdrawal of Courses/Course-Combination</h4>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        {showWithdrawlCourse?.length > 0 ? <>
                                            <div className="inner-herbpage-service-title-sub pt-2">
                                                <h1 className="m-0 p-0 pb-2">Withdrawal of Courses/Course-Combination , If Withdrawal is approved by University</h1>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Slno.</th>
                                                            <th>Academic Program Type</th>
                                                            <th>Course /Program</th>
                                                            <th>Branch /Combination</th>
                                                            <th>Medium</th>
                                                            <th>Intake Approved for {AC_YEAR_OLD}</th>
                                                            <th>Accreditation Conferred (NBA/NAAC)</th>
                                                            <th>Affiliation Valid up to</th>
                                                            <th>Approved No. of sections</th>
                                                            <th>Course Duration</th>
                                                            <th>Withdrawal</th>
                                                            <th>Reason</th>
                                                            <th>No. of Sections being Withdrawn</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ textAlign: "center" }}>
                                                        {showWithdrawlCourse && showWithdrawlCourse?.map((pgdd, i) => (
                                                            <tr>
                                                                <td> {i + 1} </td>

                                                                <td className='text-left'>{pgdd.course_group_desc}</td>

                                                                <td className='text-left'>{pgdd.course_cat_name}</td>

                                                                <td className='text-left'>{pgdd.course_name}</td>

                                                                <td>{pgdd.name}</td>

                                                                <td>{pgdd.final_sanction_intake}</td>

                                                                <td>{pgdd.accredition}</td>

                                                                <td>{pgdd.affl_valid_upto}</td>

                                                                <td>{pgdd.approv_no_of_sections}</td>

                                                                <td>{pgdd.duration}</td>

                                                                <td>{pgdd.course_withdrawl}</td>

                                                                <td className='text-left'>{pgdd.course_withdrawl_reason}
                                                                </td>

                                                                <td>{pgdd.withdraw_no_of_sections}
                                                                </td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </> :
                                            <h5 className="afflinner-head mb-0">No Details Given in Application Category section</h5>
                                        }
                                        {showWithdrawlTotCoursesCourseData?.length > 0 ? <>
                                            <div className="table-responsive">
                                                <table className="table table-condensed table-bordered table-sm table-responsive">
                                                    <thead>
                                                        <tr>
                                                            <th >Total Number of Courses after withdrawl</th>
                                                            <th >Total Number of Branch/combinations after withdrawl</th>
                                                            <th >Total Number of Sections after withdrawal </th>
                                                            <th >Total Area( Class Rooms ) that will be released after the Withdrawal  (in Sqmtrs) </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ textAlign: "center" }}>
                                                        <tr>

                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfCoursesAfterWithdrawl"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfCombinationsAfterWithdrawl"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfSectionsAfterWithdrawl"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totClassAreaWithdrawl"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <bie.Row className="px-3 pt-4">
                                                <div className='d-flex flex-row justify-content-end pb-1'>
                                                    <button type="button" className="btn rounded-0 btn-success btn-sm"
                                                        onClick={() => {
                                                            SaveWithdrawlCourses(
                                                                afflCourseIntakeformik?.values?.totNoOfCoursesAfterWithdrawl,
                                                                afflCourseIntakeformik?.values?.totNoOfCombinationsAfterWithdrawl,
                                                                afflCourseIntakeformik?.values?.totNoOfSectionsAfterWithdrawl,
                                                                afflCourseIntakeformik?.values?.totClassAreaWithdrawl,
                                                            )
                                                        }}>Save & Continue</button>
                                                </div>
                                            </bie.Row>
                                        </> : <></>}
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2"
                                //    onClick={()=>{ClearOtherFields("2")}}
                                >
                                    <Accordion.Header>
                                        <h4 className="mb-0">3. Additional Sections to the Existing Courses /Combinations</h4>
                                    </Accordion.Header>
                                    <Accordion.Body>

                                        {showadditionalSectionsData?.length > 0 ? <>
                                            <div className="inner-herbpage-service-title-sub pt-2"  >
                                                <h1 className="m-0 p-0 pb-2">Additional Sections to the Existing Courses /Combinations<br />
                                                    If Additional Sections for the Existing Courses / Combinations is
                                                    approved by University</h1>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                                    <thead>
                                                        <tr >
                                                            <th >Slno.</th>
                                                            <th >Academic Program Type </th>
                                                            <th >Course /Program</th>
                                                            <th >Branch /Combination</th>
                                                            <th >Medium</th>
                                                            <th >Intake Approved for {AC_YEAR_OLD}</th>
                                                            <th >Intake being requested</th>
                                                            <th >Approved Number of Sections</th>
                                                            <th >Course Duration</th>
                                                            <th >Additional Number of Sections
                                                                being requested (other than that are approved)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ textAlign: "center" }}>
                                                        {showadditionalSectionsData && showadditionalSectionsData?.map((pgdd, i) => (
                                                            <tr>

                                                                <td>{i + 1}</td>
                                                                <td className='text-left'>{pgdd.course_group_desc}</td>

                                                                <td className='text-left'>{pgdd.course_cat_name}</td>

                                                                <td className='text-left'>{pgdd.course_name}</td>

                                                                <td>{pgdd.name}</td>

                                                                <td>{pgdd.final_sanction_intake}</td>


                                                                <td>{pgdd.exst_course_requested_intake_21}</td>


                                                                <td>{pgdd.approv_no_of_sections}</td>
                                                                <td>{pgdd.duration}</td>

                                                                <td>{pgdd.addl_course_requested_sections_21}</td>


                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="table-responsive">
                                                <table className="table table-condensed table-bordered table-sm table-responsive">
                                                    <thead>
                                                        <tr>
                                                            <th>Total Number of Courses</th>
                                                            <th>Total Number of
                                                                Branch/combination</th>
                                                            <th>Total Additional Number of Sections requested </th>
                                                            <th>Total Number of Sections after New sections are added </th>
                                                            <th>Total Area( Class Rooms ) that will be required for the Additional Sections (sqmtrs) </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ textAlign: "center" }}>
                                                        <tr>

                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfCoursesAdditional"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfCombinationsAdditional"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfSectionsRequestedAdditional"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfSectionsAfterNewSectionsAdditional"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totClassAreaAdditional"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <bie.Row className="px-3 pt-4">
                                                <div className='d-flex flex-row justify-content-end pb-1'>
                                                    <button type="button" className="btn rounded-0 btn-success btn-sm"
                                                        onClick={() => {
                                                            SaveAdditionalSectionsExistingCourses(afflCourseIntakeformik?.values?.totNoOfCoursesAdditional,
                                                                afflCourseIntakeformik?.values?.totNoOfCombinationsAdditional,
                                                                afflCourseIntakeformik?.values?.totNoOfSectionsRequestedAdditional,
                                                                afflCourseIntakeformik?.values?.totNoOfSectionsAfterNewSectionsAdditional,
                                                                afflCourseIntakeformik?.values?.totClassAreaAdditional
                                                            )
                                                        }}>Save & Continue</button>
                                                </div>
                                            </bie.Row>
                                        </> : <h5 className="afflinner-head mb-0">No Details Given in Application Category section</h5>}
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3"
                                //   onClick={()=>{ClearOtherFields("3")}}
                                >
                                    <Accordion.Header>
                                        <h4 className="mb-0">4. Addition of New course / combination</h4>
                                    </Accordion.Header>
                                    <Accordion.Body>

                                        {showadditionalNewCoursesData?.length > 0 ? <>
                                            <div className="inner-herbpage-service-title-sub pt-2"  >
                                                <h1 className="m-0 p-0 pb-2">Addition of New course / combination</h1>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-bordered  table-responsive renewCourseIntake-table affl-table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "5%" }}>S.No</th>
                                                            <th style={{ width: "100px" }}>Academic Program Type</th>
                                                            <th style={{ width: "100px" }}>Course /Program</th>
                                                            <th style={{ width: "100px" }}>Branch /Combination</th>
                                                            <th style={{ width: "80px" }}>Medium</th>
                                                            <th style={{ width: "85px" }}>Regular/Self-Financed</th>
                                                            <th style={{ width: "100px" }}>Afiliation
                                                                Permanent/Temporary</th>
                                                            <th >Has competent Authority(
                                                                AICTE/CHE/BCI/PCI) Approved this course for Academic year
                                                                {AC_YEAR_OLD}</th>
                                                            <th >Is this course available
                                                                in the Latest EOP/EOA issued by the competent Authority</th>
                                                            <th >If available Please
                                                                specify the Intake approved by competent Authority</th>
                                                            <th >Intake being requested
                                                                by College for this academic year {AC_YEAR_OLD}</th>
                                                            <th >Number of Sections being
                                                                requested</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ textAlign: "center" }}>
                                                        {showadditionalNewCoursesData && showadditionalNewCoursesData?.map((details, i) => (
                                                            <tr>

                                                                <td>{i + 1}</td>

                                                                <td className='text-left'>{details.course_group_desc}</td>
                                                                <td className='text-left'>{details.course_cat_name}</td>
                                                                <td className='text-left'>{details.course_name}</td>

                                                                <td>{details.name}</td>
                                                                <td>{details.reg_self}</td>

                                                                <td>{details.course_affl_type}</td>
                                                                <td>{details.addl_course_competent_auth_appr_21}</td>

                                                                <td>{details.addl_course_eoa_eop_21}</td>

                                                                <td>{details.addl_course_competent_auth_intake_21}</td>

                                                                <td>{details.addl_course_requested_intake_21}</td>

                                                                <td>{details.approv_no_of_sections}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="table-responsive">
                                                <table className="table table-condensed table-bordered table-sm table-responsive">
                                                    <thead>
                                                        <tr>
                                                            <th>Total Number of Courses after Addition of New course/ Combination </th>
                                                            <th>Total Number of Branches / Combinations after Addition of New course/ Combination</th>
                                                            <th>Total Number of Sections after Addition of New course/ Combination</th>
                                                            <th>Total Area( Class Rooms ) that will be required for New Course / Combination  </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ textAlign: "center" }}>
                                                        <tr>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfCoursesNewCourse"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfCombinationsNewCourse"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totNoOfSectionsNewCourse"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>
                                                            <td>
                                                                <Field type="text" className="form-control" name="totClassAreaAdditionalNewCourse"
                                                                    maxlength="3" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                                            </td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <bie.Row className="px-3 pt-4">
                                                <div className='d-flex flex-row justify-content-end pb-1'>
                                                    <button type="button" className="btn rounded-0 btn-success btn-sm"
                                                        onClick={() => {
                                                            SaveAdditionalNewCourses(afflCourseIntakeformik?.values?.totNoOfCoursesNewCourse,
                                                                afflCourseIntakeformik?.values?.totNoOfCombinationsNewCourse,
                                                                afflCourseIntakeformik?.values?.totNoOfSectionsNewCourse,
                                                                afflCourseIntakeformik?.values?.totClassAreaAdditionalNewCourse
                                                            )
                                                        }}>Save & Continue</button>
                                                </div>
                                            </bie.Row>
                                        </> : <h5 className="afflinner-head mb-0">No Details Given in Application Category section</h5>}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Form>
                    </FormikProvider >
                </bie.Container>
            </bie.Container >
        </>
    )
}
